import { Search } from '@mui/icons-material'
import { MenuItem, styled, TextField } from '@mui/material'
import theme from 'lib/theme'

export const SearchField = styled(TextField, {
  shouldForwardProp: (props) =>
    props !== 'backgroundColor' && props !== 'queries',
})<{
  backgroundColor: string
  queries?: { [key: string]: string } | null
}>(({ backgroundColor, queries }) => ({
  minWidth: '300px',
  marginRight: theme.spacing(4),
  transition: '0.5s',
  '& .MuiOutlinedInput-root': {
    height: theme.spacing(5),
    padding: '2px',
    paddingRight: 0,
    border: '1px solid',
    borderColor:
      backgroundColor === theme.palette.commonColors.white
        ? theme.palette.primary.main
        : 'transparent',
    backgroundColor,
    fontWeight: 'bold',
    '&.Mui-focused fieldset': {
      border: 0,
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: 0,
  },
  '& .MuiOutlinedInput-input': {
    '&:hover': { color: theme.palette.text.primary },
  },
  '& .MuiFormHelperText-root': {
    color: theme.palette.primary.main,
  },
  '& .MuiAutocomplete-inputRoot': {
    flexWrap: 'nowrap',
  },
  input: {
    color: theme.palette.text.primary,
    '&::placeholder': {
      color: theme.palette.text.secondary,
      fontWeight: 'bold',
      opacity: 1,
      transition: '0.5s',
    },
  },
  [theme.breakpoints.between('xs', 'sm')]: {
    marginTop: theme.spacing(1),
    marginRight: 0,
    '& .MuiOutlinedInput-root': {
      height: 'auto',
    },
    '& .MuiOutlinedInput-input': {
      marginTop: queries ? `${40 * Object.keys(queries).length}px` : 0,
    },
  },
}))

export const OrderSearchIcon = styled(Search, {
  shouldForwardProp: (props) => props !== 'hover',
})<{ hover: boolean }>(({ hover }) => ({
  fill: hover ? theme.palette.text.primary : theme.palette.text.secondary,
  transition: '0.5s',
}))

export const SearchMenuItem = styled(MenuItem, {
  shouldForwardProp: (props) => props !== 'iconHover' && props !== 'width',
})<{ iconHover: boolean; width: string }>(({ iconHover, width }) => ({
  transition: '0.5s',
  borderBottom: '0.1px solid',
  '&.MuiAutocomplete-option': {
    paddingRight: theme.spacing(1),
  },
  '.MuiSvgIcon-root': {
    fill: iconHover
      ? theme.palette.icon.selected
      : theme.palette.text.secondary,
  },
  width,
  [theme.breakpoints.between('xs', 'sm')]: {
    marginTop: theme.spacing(1),
  },
  borderColor: theme.palette.neutral.grey7,
}))
